import axios from '@axios'
export const state = {
  groups: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 1,
}

export const getters = {
  allGroups: (state) => state.groups,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}
export const mutations = {
  GET_GROUPS: (state, data) => {
    if (!data) return false
    state.groups = data.groups
    state.currentPage = data.page
    state.perPage = data.perPage
    state.totalPages = data.totalPages
    state.totalRecords = data.totalRecords
  },
  GET_GROUP: (state, group) => {
    state.group = group
  },
  CREATE_GROUP: (state, group) => {
    state.groups.unshift(group)
  },
  UPDATE_GROUP: (state, updatedGroup) => {
    state.groups.filter((group, index) => {
      if (group.id === updatedGroup.id) {
        state.groups[index].name = updatedGroup.name
        state.groups[index].description = updatedGroup.description
      }
    })
  },
  REMOVE_GROUP: (state, deletedGroup) => {
    state.groups = state.groups.filter((gro) => gro.id !== deletedGroup.id)
  },
}

export const actions = {
  async getGroups({ commit }, params = {}) {
    let { _commit } = params
    if (typeof _commit === 'boolean' && _commit === false)
      return axios.get('/sms/contact-groups', { params: params })
    await axios.get('/sms/contact-groups', { params: params }).then((resp) => {
      if (resp.status === 200) {
        commit('GET_GROUPS', resp.data)
      }
    })
  },
  getGroupsAxios({ commit }, params = {}) {
    return axios.get('/sms/contact-groups', { params: params })
  },
  async getGroup({ commit }, group) {
    return axios.get(`/sms/contact-groups/${group.id}`)
  },
  async createGroup({ commit }, group) {
    if (group.hasOwnProperty('contacts') && group.contacts.length === 0)
      delete group.contacts

    await axios.post(`/sms/contact-groups`, group).then((resp) => {
      if (resp.status === 201) {
        commit('CREATE_GROUP', resp.data)
      }
    })
  },
  async updateGroup({ commit }, groups) {
    await axios.put(`/sms/contact-groups`, groups).then((resp) => {
      if (resp.status === 200) {
        commit('UPDATE_GROUP', groups)
      }
    })
  },
  async removeGroup({ commit }, group) {
    await axios
      .delete(`/sms/contact-groups/${group.id}`, group)
      .then((resp) => {
        if (resp.status === 204) {
          commit('REMOVE_GROUP', group)
        }
      })
  },
}
